import { useQuery } from '@tanstack/react-query';

import { PrependUrl } from 'enums';
import { fetchWithCsrfToken } from 'utils/fetchWrapper';

export interface PaymentDetails {
  amount: string;
  currency: string;
}

type PaymentDetailsResponse = PaymentDetails | null;

const useGetPaymentDetails = (interviewUid: string) => {
  const body = {
    interview: interviewUid,
  };

  const { data, isLoading, isError } = useQuery<PaymentDetailsResponse, Error>(
    ['getPaymentDetails', interviewUid],
    async () =>
      fetchWithCsrfToken<PaymentDetailsResponse>(
        `${PrependUrl.ASYNC}/payment/get_details`,
        'POST',
        body
      ),
    {
      enabled: !!interviewUid,
    }
  );

  return {
    data,
    isLoading,
    isError,
  };
};

export default useGetPaymentDetails;
